import {
  selectIsConnectedToRoom,
  selectLocalPeerRole,
  useHMSActions,
  useHMSStore,
  useParticipantList,
} from '@100mslive/react-sdk';
import { useEffect, useState } from 'react';
import './App.css';
import EdtechComponent from './ThemeComponents/EdtechComponent';
import './MeetingMsViewCss.css';
import {
  getClientHostToken,
  getClienttoken,
  getMeetingToekn,
} from './services/100-ms-services/ApiUtils';
import BaseService from './utils/BaseService';
import { ApolloProvider } from '@apollo/client';
import ApolloClient from './services/ApolloClient';
import { onError } from '@apollo/client/link/error';

function App() {
  const [stateData, setStateData] = useState({
    roomState: 'Preview',
  });
  const [authTokenObj, setAuthTokenObj] = useState({
    name: '',
    authToken: '',
    meetingUrl: '',
    accountId: '',
  });
  const searchParam = window.location.search;
  const token = searchParam ? searchParam.replaceAll('?token=', '') : 'invalid';
  const { roles, participantsByRoles, peerCount } = useParticipantList();
  const hmsStore = useHMSStore(selectLocalPeerRole);
  console.log(roles, participantsByRoles, peerCount);

  const decoded: string = token ? window.atob(token as string) : '';
  const meetingObj = decoded?.length
    ? (JSON.parse(decoded) as any)
    : ({} as any);
  console.log(meetingObj);

  const handleMeetingStart = () => {
    if (
      peerCount > 1 &&
      peerCount < 3 &&
      hmsStore?.name === 'role-doc' &&
      meetingObj.appointmentDetails &&
      meetingObj.appointmentDetails.startMeetingHook
    ) {
      const axios = BaseService.getSharedInstance().axios;
      axios
        .put(
          meetingObj.appointmentDetails.startMeetingHook,
          {
            eventName: 'START',
          },
          {
            headers: {
              'x-hasura-admin-secret': meetingObj.appointmentDetails.secret,
              'account-uuid': meetingObj.appointmentDetails.accountUUID,
            },
          }
        )
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const onPreview = async () => {
    if (token === 'invalid') {
      return;
    }
    const decoded: string = token ? window.atob(token as string) : '';
    const meetingObj = decoded?.length
      ? (JSON.parse(decoded) as any)
      : ({} as any);
    console.log(meetingObj);
    if (meetingObj && meetingObj?.id) {
      const response = await getMeetingToekn(meetingObj);
      const meetingObjRes = response?.data;
      const name = meetingObjRes?.data?.name
        ? meetingObjRes?.data?.name
        : meetingObjRes?.data?.firstName || meetingObjRes?.data?.lastName
          ? `${meetingObjRes?.data?.firstName || '' + ' ' || ''}${meetingObjRes?.data?.lastName || ''
          }`
          : '';
      const otherName = meetingObj?.name
        ? meetingObj?.name
        : meetingObj?.firstName || meetingObj?.lastName
          ? `${meetingObj?.firstName || '' + ' ' || ''}${meetingObj?.lastName || ''}`
          : '';
      if (meetingObjRes?.data?.clientToken) {
        setAuthTokenObj((prev) => {
          return {
            ...prev,
            authToken: meetingObjRes?.data?.clientToken,
            name: name || otherName || 'Guest',
            accountId: meetingObj?.accountId,
          };
        });
      } else {
        console.log('guest invalid flow', response);
        return;
      }
    } else if (meetingObj && meetingObj?.joineeType === 'GUEST') {
      const response = await getClienttoken(meetingObj);
      const meetingObjRes = response?.data;
      const name = meetingObjRes?.data?.name
        ? meetingObjRes?.data?.name
        : meetingObjRes?.data?.firstName || meetingObjRes?.data?.lastName
          ? `${meetingObjRes?.data?.firstName || '' + ' ' || ''}${meetingObjRes?.data?.lastName || ''
          }`
          : '';
      const otherName = meetingObj?.name
        ? meetingObj?.name
        : meetingObj?.firstName || meetingObj?.lastName
          ? `${meetingObj?.firstName || '' + ' ' || ''}${meetingObj?.lastName || ''}`
          : '';
      if (meetingObjRes?.data?.clientToken) {
        setAuthTokenObj((prev) => {
          return {
            ...prev,
            authToken: meetingObjRes?.data?.clientToken,
            name: name || otherName || 'Guest',
            accountId: meetingObj?.accountId,
          };
        });
      } else {
        console.log('guest invalid flow', response);
        return;
      }
    } else if (meetingObj && meetingObj.meetingId) {
      const response = await getClientHostToken(meetingObj);
      const meetingObjRes = response?.data;
      if (meetingObjRes?.data?.clientToken) {
        setAuthTokenObj((prev) => {
          return {
            ...prev,
            authToken: meetingObjRes?.data?.clientToken,
            name: meetingObjRes?.data?.name || meetingObj.name || 'Host',
            meetingUrl: meetingObjRes?.data?.meetingUrl,
            accountId: meetingObj?.accountId,
          };
        });
      } else {
        console.log('guest invalid flow', response);
        return;
      }
    } else {
      const otherName = meetingObj?.userName
        ? meetingObj?.userName
        : meetingObj?.firstName || meetingObj?.lastName
          ? `${meetingObj?.firstName + ' ' || ''}${meetingObj?.lastName || ''}`
          : '';
      setAuthTokenObj((prev) => {
        return {
          ...prev,
          authToken: meetingObj.authToken,
          name: otherName || 'Guest',
          meetingUrl: meetingObj.meetingUrl,
          accountId: meetingObj?.accountId,
        };
      });
      // hmsActions.join(meetingObj);
    }
  };
  const hmsActions = useHMSActions();
  const isConnected = useHMSStore(selectIsConnectedToRoom);

  useEffect(() => {
    onPreview();
    window.addEventListener('beforeunload', () => hmsActions.leave());
    window.addEventListener('onunload', () => hmsActions.leave());
  }, []);

  useEffect(() => {
    setStateData((prev) => {
      return {
        ...prev,
        roomState: isConnected ? 'Connected' : 'Preview',
      };
    });
  }, [isConnected]);

  useEffect(() => {
    handleMeetingStart();
  }, [peerCount]);

  const errorLink = onError((data) => {
    //
  });
  
  return (
    <ApolloProvider client={ApolloClient.getClient(errorLink)}>
      <EdtechComponent
        stateData={stateData}
        authTokenObj={authTokenObj}
        onActionPerformed={() => {
          setStateData((prev) => {
            return {
              ...prev,
              roomState: 'Connected',
            };
          });
        }}
      />
    </ApolloProvider>
  );
}

export default App;
